import React, { useMemo } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getFormQuestionAttributeEndDateQuestionUuid, getFormQuestionAttributeStartDateQuestionUuid } from "reduxSlices/formBuilderSlice"
import FormsyValidation from "shared/FormsyValidation"

const NoBlankDatesValidation = ({ sectionIndex, questionIndex }) => {
  const questionEndDateQuestionUuid = useSelector(getFormQuestionAttributeEndDateQuestionUuid({ sectionIndex, questionIndex }))
  const questionStartDateQuestionUuid = useSelector(getFormQuestionAttributeStartDateQuestionUuid({ sectionIndex, questionIndex }))

  const value = useMemo(
    () => [questionEndDateQuestionUuid, questionStartDateQuestionUuid],
    [questionEndDateQuestionUuid, questionStartDateQuestionUuid],
  )

  return (
    <FormsyValidation
      name={`sections[${sectionIndex}].questions[${questionIndex}].noBlankDates`}
      value={value}
      validations={{
        noBlankDates(_model, val) {
          if (val?.every(Boolean)) return true
          return "Must have dates selected"
        },
      }}
    />
  )
}

NoBlankDatesValidation.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default NoBlankDatesValidation
